module.exports = __webpack_public_path__ + "static/media/by_default_cuff.0a7cff9c.svg";